/* eslint-disable padding-line-between-statements */
const UA = navigator.userAgent;

const isIOS = /(iPhone|iPad|iPod)/i.test(UA);

const isHuaweiBrowser = /HuaweiBrowser/i.test(UA);

const isQQBrowser = /QQBrowser/i.test(UA);

const isInIframe = (() => {
	try {
		return window.self !== window.top;
	} catch (_) {
		return true;
	}
})();

const iOSMajorVersion = (() => {
	if (isIOS) {
		const version = UA.match(/OS ((\d+_?){2,3})\s/)[1] || '';

		return Number(version.split('_')[0]);
	}
})();

const isMatchedIOSVersionOrHigher = targetVersion => {
	if (isIOS) {
		const match = UA.match(/OS (\d+)[._](\d+)[._]?(\d+)?/);
		if (match && match.length > 1) {
			const major = parseInt(match[1], 10);
			const minor = parseInt(match[2], 10) || 0;
			const patch = parseInt(match[3], 10) || 0;

			const [targetMajor, targetMinor, targetPatch] = targetVersion.split('.').map(Number);

			if (
				major > targetMajor ||
				(major === targetMajor && minor > targetMinor) ||
				(major === targetMajor && minor === targetMinor && patch >= targetPatch)
			) {
				return true;
			}
		}
	}
	return false;
};

const getBrowserInfo = () => ({
	userAgent: navigator.userAgent,
	language: navigator.language,
	cookiesEnabled: navigator.cookieEnabled,
	online: navigator.onLine,
});

const getNetworkInfo = () => {
	const connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
	if (!connection) {
		return {};
	}

	return {
		type: connection.effectiveType,
		downlink: `${connection.downlink} Mbps`,
		rtt: `${connection.rtt} ms`,
		saveData: connection.saveData,
	};
};

const getUserEnvironment = () => ({
	browser: getBrowserInfo(),
	network: getNetworkInfo(),
});

export {
	isIOS,
	isHuaweiBrowser,
	isQQBrowser,
	isInIframe,
	iOSMajorVersion,
	isMatchedIOSVersionOrHigher,
	getUserEnvironment,
};
